import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";

import Typography from "../../../../components/Typography";

import { ReactComponent as SearchCheckIcon } from "../../../../build/images/nps-dashboard-icons/search_check.svg";
import { ReactComponent as SupervisorAccountIcon } from "../../../../build/images/nps-dashboard-icons/supervisor_account.svg";
import { ReactComponent as ClockLoaderIcon } from "../../../../build/images/nps-dashboard-icons/clock_loader_10.svg";
import { ReactComponent as NewAnsweredIcon } from "../../../../build/images/nps-dashboard-icons/new-answered-icon-nps-date-one-call.svg";
import { ReactComponent as NewSentToEvaluationIcon } from "../../../../build/images/nps-dashboard-icons/new-sent-to-evaluation-icon-nps-date-one-call.svg";
import { ReactComponent as NewAssessmentsStartedIcon } from "../../../../build/images/nps-dashboard-icons/new-assessments-started-icon-nps-date-one-call.svg";
import { ReactComponent as NewCompletedAssessmentIcon } from "../../../../build/images/nps-dashboard-icons/new-completed-assessment-icon-nps-date-one-call.svg";

import "./nps-date-one.css";
import Paperplane from "../../../Loading/Paperplane";
import CardChannelBased from "../CardChannelBased";
import axios from "axios";
import {
  getSentSurveysCall,
  getSentSurveysMidiaCall,
} from "../../../../actions";

export default function NpsDateOne({
  setIsLoadingSurveyInfos,
  setSurveyInfosFromDateOne,
  setLoadingFromDateOne,
}) {
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );
  const cardsOfCallCenterDash = useSelector(
    (state) => state.cardsOfCallCenterDash
  );

  const [surveyInfos, setSurveyInfos] = useState({
    answered: "0",
    percentEvalueted: "0",
    sended: 0,
    percentSended: "0",
    evalueted: "0",
    iniciadas: "0",
    porcentagemIniciadas: "0",
    concluidas: 0,
    porcentagemConcluidas: "0",
  });
  const [loading, setLoading] = useState(false);
  const [dataChannelBased, setDataChannelBased] = useState([]);
  const [loadingDataChannelBased, setLoadingDataChannelBased] = useState(false);

  const hasDataChannelBased = !!dataChannelBased && dataChannelBased.length > 0;

  const surveyData = [
    {
      icon: <NewAnsweredIcon />,
      number: surveyInfos.answered,
      information: "Quantidade atendidas",
      class: "survey-data-agent-item sent-surveys",
    },
    {
      icon: <NewSentToEvaluationIcon />,
      number: (
        <div className="infos-numbers-of-survey-data-call-center">
          <span className="infos-numbers-of-survey-data-call-center__qtd">{`${surveyInfos.sended}`}</span>
          <div className="infos-numbers-of-survey-data-call-center__percentage-info">
            <span className="infos-numbers-of-survey-data-call-center__dot">
              •
            </span>
            <span className="infos-numbers-of-survey-data-call-center__percentage">{`${surveyInfos.percentSended}%`}</span>
          </div>
        </div>
      ),
      information: (
        <p className="text-of-survey-data-call-center">
          Atendimentos enviados para avaliação
        </p>
      ),
      class: "survey-data-agent-item sent-surveys",
    },
    {
      icon: <NewAssessmentsStartedIcon />,
      number: (
        <div className="infos-numbers-of-survey-data-call-center">
          <span className="infos-numbers-of-survey-data-call-center__qtd">{`${surveyInfos.iniciadas}`}</span>
          <div className="infos-numbers-of-survey-data-call-center__percentage-info">
            <span className="infos-numbers-of-survey-data-call-center__dot">
              •
            </span>
            <span className="infos-numbers-of-survey-data-call-center__percentage">{`${surveyInfos.porcentagemIniciadas}%`}</span>
          </div>
        </div>
      ),
      information: "Avaliações iniciadas",
      class: "survey-data-agent-item sent-surveys",
    },
    {
      icon: <NewCompletedAssessmentIcon />,
      number: (
        <div className="infos-numbers-of-survey-data-call-center">
          <span className="infos-numbers-of-survey-data-call-center__qtd">{`${surveyInfos.concluidas}`}</span>
          <div className="infos-numbers-of-survey-data-call-center__percentage-info">
            <span className="infos-numbers-of-survey-data-call-center__dot">
              •
            </span>
            <span className="infos-numbers-of-survey-data-call-center__percentage">{`${surveyInfos.porcentagemConcluidas}%`}</span>
          </div>
        </div>
      ),
      information: (
        <p className="text-of-survey-data-call-center">
          Avaliações completadas
        </p>
      ),
      class: "survey-data-agent-item sent-surveys",
    },
  ];

  async function getDataChannelBasedV2(source) {
    let updatedData = [];
    const response = await getSentSurveysMidiaCall(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      source,
      setLoadingDataChannelBased
    );
    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.length
    ) {
      updatedData = response.data.map((midiaInfo) => {
        return {
          midiaId: midiaInfo.id_midia,
          sent: midiaInfo.qtde_enviada,
          answered: midiaInfo.qtde_finalizada,
          all: midiaInfo.qtde_atendimento,
          enviadas: midiaInfo.qtde_enviada,
          iniciadas: midiaInfo.qtde_iniciada,
          completadas: midiaInfo.qtde_finalizada,
        };
      });
    }

    setDataChannelBased(updatedData);
  }

  async function getSentSurveys(source) {
    let updatedSurveyInfos = {
      answered: "0",
      percentEvalueted: "0",
      sended: 0,
      percentSended: "0",
      evalueted: "0",
      iniciadas: "0",
      porcentagemIniciadas: "0",
      concluidas: 0,
      porcentagemConcluidas: "0",
    };
    setIsLoadingSurveyInfos(true);
    setLoading(true);
    setLoadingFromDateOne(true);

    const response = await getSentSurveysCall(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      source
    );

    if (response && response.status === 200) {
      const data = response.data;
      const newSurveyData = data.map((datum) => ({
        enviadas: datum.qtde_atendida,
        respondidas: datum.qtde_respondida,
        clientes: datum.qtde_respondida,
        porcentagemClientes:
          Number(datum.qtde_atendida) > 0
            ? ((datum.qtde_respondida / datum.qtde_atendida) * 100).toFixed(2)
            : 0,
        tempMedio: datum.media_resposta_pesquisa
          ? handleTempMed(datum.media_resposta_pesquisa)
          : "0",
        answered: datum.qtde_atendida,
        percentEvalueted: Number(datum.qtd_enviada)
          ? Number((datum.qtde_respondida / datum.qtd_enviada) * 100).toFixed(2)
          : 0,
        sended: datum.qtd_enviada,
        percentSended: Number(datum.qtde_atendida)
          ? (
              (Number(datum.qtd_enviada) / Number(datum.qtde_atendida)) *
              100
            ).toFixed(2)
          : 0,
        evalueted: datum.qtde_respondida,
        finished: datum.qtde_finalizada,
        iniciadas: datum.qtde_iniciada,
        porcentagemIniciadas: Number(datum.qtd_enviada)
          ? (
              (Number(datum.qtde_iniciada) / Number(datum.qtd_enviada)) *
              100
            ).toFixed(2)
          : 0,
        concluidas: datum.qtde_finalizada,
        porcentagemConcluidas: Number(datum.qtd_enviada)
          ? (
              (Number(datum.qtde_finalizada) / Number(datum.qtd_enviada)) *
              100
            ).toFixed(2)
          : 0,
      }));

      updatedSurveyInfos = newSurveyData[0];
      setSurveyInfos(updatedSurveyInfos);
      setSurveyInfosFromDateOne(updatedSurveyInfos);
      setIsLoadingSurveyInfos(false);
      setLoading(false);
      setLoadingFromDateOne(false);
    } else {
      setSurveyInfos(updatedSurveyInfos);
      setSurveyInfosFromDateOne(updatedSurveyInfos);
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setIsLoadingSurveyInfos(false);
          setLoading(false);
          setLoadingFromDateOne(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  function handleTempMed(tempMed) {
    // ANO | MES | DIA | HORA | MINUTO | SEGUNDO
    const cutTime = tempMed.split("|");
    let ano = cutTime[0];
    let mes = cutTime[1];
    let dia = cutTime[2];
    let hora = cutTime[3];
    let minuto = cutTime[4];
    let segundo = cutTime[5];

    if (ano !== "0000") {
      return `${Number(ano)} ano(s)`;
    } else if (mes !== "00") {
      const corrigirMeses = Number(mes);
      return `${Number(mes)} ${corrigirMeses > 1 ? "meses" : "mês"}`;
    } else if (dia !== "00") {
      return `${Number(dia)} dia(s)`;
    } else if (hora !== "00") {
      return `${Number(hora)} hora(s)`;
    } else if (minuto !== "00") {
      return `${Number(minuto)} minuto(s)`;
    } else if (segundo !== "00") {
      return `${Number(segundo)} segundo(s)`;
    }
  }

  useEffect(() => {
    const sourceChannel = axios.CancelToken.source();
    const sourceSurveys = axios.CancelToken.source();

    if (!!agentDashboardFilter) {
      getSentSurveys(sourceSurveys);
      getDataChannelBasedV2(sourceChannel);
    }

    return () => {
      sourceChannel.cancel("Operation canceled by the user. (sourceChannel)");
    };
  }, [agentDashboardFilter]);

  return (
    <section className="nps-date-one-holder nps-date-one-holder-call-center">
      {cardsOfCallCenterDash.card3 && (
        <section className="nps-date-one-holder__item-call-center">
          <div className="nps-date-one__header">
            <h4>Resumo</h4>
          </div>
          <section className="nps-date-one nps-date-one-dashboard-agent">
            {loading ? (
              <Paperplane className="nps-date-one__loading" />
            ) : (
              surveyData.map((data, index) => (
                <div key={index} className={data.class}>
                  <span
                    className={`${data.class}__icon nps-date-one-dashboard-agent__icon`}
                  >
                    {data.icon}
                  </span>

                  <span className={`${data.class}__text`}>
                    <Typography.H1
                      weight="700"
                      className={`${data.class}__text__number`}
                    >
                      {data.number}
                    </Typography.H1>

                    <Typography.H6
                      className={`${data.class}__text__information`}
                      weight="400"
                    >
                      {data.information}
                    </Typography.H6>
                  </span>
                </div>
              ))
            )}
          </section>
        </section>
      )}
      {cardsOfCallCenterDash.card4 && (
        <section className="nps-date-one-holder__item-call-center">
          <div className="nps-date-one__header">
            <h4>Avaliação por canal</h4>
          </div>
          {loadingDataChannelBased ? (
            <div className="nps-date-one-holder__item__loading">
              <Paperplane className="nps-date-one__loading" />
            </div>
          ) : (
            <div className="nps-date-one nps-date-one-col2 nps-date-one-col2-dashboard-agent">
              {hasDataChannelBased &&
                dataChannelBased.map((datum, index) => {
                  const hasEnviadas =
                    !!datum.enviadas && datum.enviadas !== "0";
                  if (hasEnviadas) {
                    return (
                      <div key={index}>
                        <CardChannelBased
                          midiaId={datum.midiaId}
                          sent={datum.sent ? datum.sent : "--"}
                          answered={datum.answered ? datum.answered : "--"}
                          all={datum.all ? datum.all : "--"}
                          enviadas={datum.enviadas ? datum.enviadas : "--"}
                          iniciadas={datum.iniciadas ? datum.iniciadas : "--"}
                          completadas={
                            datum.completadas ? datum.completadas : "--"
                          }
                        />
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              {/*<div>
              <CardChannelBased
                midiaId={dataChannelBased.sms.midiaId}
                sent={
                  dataChannelBased.sms.sent
                    ? formatNumberToString(dataChannelBased.sms.sent)
                    : "--"
                }
                answered={
                  dataChannelBased.sms.answered
                    ? formatNumberToString(dataChannelBased.sms.answered)
                    : "--"
                }
              />
            </div>
            <div>
              <CardChannelBased
                midiaId={dataChannelBased.whatsapp.midiaId}
                sent={
                  dataChannelBased.whatsapp.sent
                    ? formatNumberToString(dataChannelBased.whatsapp.sent)
                    : "--"
                }
                answered={
                  dataChannelBased.whatsapp.answered
                    ? formatNumberToString(dataChannelBased.whatsapp.answered)
                    : "--"
                }
              />
            </div>*/}
            </div>
          )}
        </section>
      )}
    </section>
  );
}
